import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff6eb4',
      light: '#ff9fd0',
      dark: '#c93d82',
    },
    secondary: {
      main: '#b44fff',
      light: '#d480ff',
      dark: '#8020cc',
    },
    background: {
      default: '#0d0a12',
      paper: '#160f20',
    },
    text: {
      primary: '#f0e6f6',
      secondary: '#c9a8e0',
    },
  },
  typography: {
    fontFamily: '"Noto Sans JP", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 50,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(255, 110, 180, 0.15)',
        },
      },
    },
  },
});

export default theme;
